import type {PhoneNumberSet} from 'src/types/chat/phone-number-sets';


export const resolveDisplayPhoneNumber = (
  phoneNumberSet?: PhoneNumberSet | null,
): string | null | undefined => phoneNumberSet?.phone_numbers[0];
